import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./DonateButton.css";

const DonateButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const history = useHistory();

  const handleClick = () => {
    history.push("/donation");
  };

  return (
    <div className="donate-button-container">
      <button
        className={`donate-button ${isHovered ? "donate-button-hover" : ""}`}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Donate to SelecTree"
      >
        <div
          className={`heart-icon-container ${
            isHovered ? "heart-icon-hover" : ""
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="heart-icon"
          >
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
        </div>
        <span className={`donate-text ${isHovered ? "donate-text-hover" : ""}`}>
          Donate Now
        </span>
        {isHovered && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="arrow-icon"
          >
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default DonateButton;
